import '.ah{position:relative;}.ssr-plugin'
import '.j1{width:64px;}.ssr-plugin'
import '.j2{height:64px;}.ssr-plugin'
import '.aj{flex-shrink:0;}.ssr-plugin'
import '.bi{position:absolute;}.ssr-plugin'
import '.j3{bottom:-4px;}.ssr-plugin'
import '.hz{right:-4px;}.ssr-plugin'
import '.fn{border-radius:50%;}.ssr-plugin'
import '.j4{border:2px solid var(--palette-white);}.ssr-plugin'
import '.b7{overflow:hidden;}.ssr-plugin'
import '.j5{width:32px;}.ssr-plugin'
import '.j6{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="ah j1 j2 aj"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bi j3 hz fn j4 b7 j5 j6"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
